import * as React from 'react';
import config from '@/server/config';
import request from '@/server/request';
import store from '@/redux';
import * as ProductEditStore from '@/redux/pages/product-edit';

const Toast = require('react-toast-mobile');

export default class YLK extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            productPopupVisible: false, // 产品表弹窗
            addProductMessage: '', // 新增产品权限提示
            addFormulaMessage: '', // 新增配方权限提示
        };
    }

    public componentDidMount() { 
        this.getAddProductPremission();
        this.getAddFormulaPremission();
    }

    public render() {
        return (
            <section className="ylk">
                <div className="ylk-container">
                    <div className="ylk-product-datas">
                        <div className="ylk-pro-data">
                            <a href={config.MULKAPI}>
                                <img className="ylk-logo" src={require('../../../assets/images/logo-ylk.png')} alt="" />
                                <div className="ylk-title">
                                    <strong>优料库</strong>
                                    <p>材料创新者 智慧数据库</p>
                                </div>
                                <img className="arrow" src={require('@/assets/images/right_icon2.png')} alt="" />
                            </a>
                        </div>
                        <div className="ylk-pro-btns">
                            <p className="icon-write-pro" onClick={() => this.setProductList(true)}>填写产品表</p>
                            <p className="icon-write-formula" onClick={() => this.addFormula()}>填写配方</p>
                        </div>
                    </div>
                    <div className="ylk-product-list">
                        <a className="ylk-product-item" href="/mobile/uc/build/u/list?type=1">
                            <img className="icon" src={require('@/assets/images/icon-ylk-claim.png')} alt="" />
                            <p>认领产品</p>
                            <img className="arrow" src={require('@/assets/images/right_icon2.png')} alt="" />
                        </a>
                        <a className="ylk-product-item" href="/mobile/uc/build/u/list?type=2">
                            <img className="icon" src={require('@/assets/images/icon-ylk-input.png')} alt="" />
                            <p>录入产品</p>
                            <img className="arrow" src={require('@/assets/images/right_icon2.png')} alt="" />
                        </a>
                        <a className="ylk-product-item" href="/mobile/uc/build/u/list?type=3">
                            <img className="icon" src={require('@/assets/images/icon-ylk-edit.png')} alt="" />
                            <p>编辑记录</p>
                            <img className="arrow" src={require('@/assets/images/right_icon2.png')} alt="" />
                        </a>
                        <a className="ylk-product-item" href="/mobile/uc/build/u/list?type=4">
                            <img className="icon" src={require('@/assets/images/icon-ylk-collection.png')} alt="" />
                            <p>收藏产品</p>
                            <img className="arrow" src={require('@/assets/images/right_icon2.png')} alt="" />
                        </a>
                        <a className="ylk-product-item" href="/mobile/uc/build/u/list?type=5">
                            <img className="icon" src={require('@/assets/images/icon-ylk-formula.png')} alt="" />
                            <p>配方中心</p>
                            <img className="arrow" src={require('@/assets/images/right_icon2.png')} alt="" />
                        </a>
                    </div>
                </div>
                <div className={`prodcut-popup ${this.state.productPopupVisible ? 'active' : ''}`}>
                    <div className="product-popup-c">
                        <div className="product-pu-row">
                            <a className="product-pu-item" href="javascript: void(0)" onClick={() => this.navigateToAddProduct('/u/product/edit?type=1&source=1')}>
                                <img src={require('@/assets/images/icon-equipment.png')} alt="" />
                                <p>生产原材料</p>
                            </a>
                            <a className="product-pu-item" href="javascript: void(0)" onClick={() => this.navigateToAddProduct('/u/product/edit?type=2&source=1')}>
                                <img src={require('@/assets/images/icon-material.png')} alt="" />
                                <p>生产设备</p>
                            </a>
                        </div>
                        <img className="product-pu-close" src={require('@/assets/images/icon-close1.png')} alt="" onClick={() => this.setProductList(false)} />
                    </div>
                </div>
            </section>
        )
    }
    /**
     * 设置产品表弹窗显示隐藏
     * @param visible {boolean} 可视化
     */
    private setProductList(visible: boolean) {
        this.setState({
            productPopupVisible: visible
        });
    }

    // 添加配方
    private addFormula() {
        if (this.state.addFormulaMessage !== '') { 
            return Toast.T.notify(this.state.addFormulaMessage);
        }
        this.props.history.push('/u/formula');
    }

    // 获取新增商品权限
    private async getAddProductPremission() { 
        const r = await request({
            url: `${config.ULKAPI}api/web/index.php?r=member/product/checkpermission&type=1`,
        });
        if (r.error_code !== 0) { 
            this.setState({
                addProductMessage: r.msg
            });
        }
    }

    // 获取新增配方权限
    private async getAddFormulaPremission() { 
        const r = await request({
            url: `${config.ULKAPI}api/web/index.php?r=member/product/checkpermission&type=2`,
        });
        if (r.error_code !== 0) { 
            this.setState({
                addFormulaMessage: r.msg
            });
        }
    }

    /**
     * 跳转新增商品
     * @param path {string} 路径
     */
    private navigateToAddProduct(path: string) { 
        if (this.state.addProductMessage !== '') { 
            return Toast.T.notify(this.state.addProductMessage);
        }
        // 重置新增商品数据
        store.dispatch({
            type: ProductEditStore.types.CLEAR
        });
        this.props.history.push(path);
    }
}